/**
 * Chinese (Traditional) translations for membership-related messages
 */
const membership = {
  membershipPaused: {
    title: "會籍已暫停",
    subtitle: "您的帳戶訪問已暫時暫停",
    message: "您的會籍已被暫停。請聯繫我們的支援團隊以獲取進一步的指示和協助。",
    instruction: "我們的支援團隊將協助您了解原因並指導您完成後續步驟。",
    supportTeam: "支援團隊",
    contactButton: "透過 WhatsApp 聯繫支援",
    responseTime: "我們的團隊通常會在 24 小時內回覆",
    signOutPrompt: "需要切換帳戶？",
    signOutButton: "登出",
  },
};

export default membership;
